<template>
  <v-data-table dense
                :headers="headers"
                :items="messages"
                :loading="loading"
                loading-text="Fetching campaign emails"
                :items-per-page="25"
                :footer-props="{'items-per-page-options': [10, 25, 50, 100, 500, 1000, -1]}"
                :search="search">
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title class="mr-4">
          <v-icon left>
            fal fa-mail-bulk
          </v-icon>
          Emails
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search"
                      append-icon="fal fa-fw fa-search"
                      autocomplete="off"
                      label="Search"
                      outlined
                      dense
                      hide-details>
        </v-text-field>
        <v-btn icon
               small
               class="ml-4 mr-1"
               @click.prevent="exportMessages">
          <v-icon>
            fal fa-fw fa-download
          </v-icon>
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.recipient="{item: message}">
      <div v-if="message.userContact">
        <div v-if="message.userContact.name">
          {{ message.userContact.name }}
        </div>
        <div>
          {{ message.userContact.email }}
        </div>
      </div>
      <div v-else>
        {{ message.recipient }}
      </div>
    </template>
    <template v-slot:item.created_at="{item: message}">
      <MessageLink :message="message"
                    :use-dialog="true">
      </MessageLink>
    </template>
    <template v-slot:item.delivered_at="{item:message}">
      <DateToolTip :date="message.delivered_at">
      </DateToolTip>
    </template>
    <template v-slot:item.opened_at="{item:message}">
      <DateToolTip :date="message.opened_at">
      </DateToolTip>
    </template>
    <template v-slot:item.clicked_at="{item:message}">
      <DateToolTip :date="message.clicked_at">
      </DateToolTip>
    </template>
    <template v-slot:item.failed_at="{item:message}">
      <DateToolTip :date="message.failed_at">
      </DateToolTip>
    </template>
    <template v-slot:item.status="{item:message}">
      <MessageStatus :message="message">
      </MessageStatus>
    </template>
  </v-data-table>
</template>
<script>
import {mapGetters} from 'vuex';
import {orderBy} from 'lodash';
import mailgunService from '../../../../../ml/services/mailgunService';
import HelpDialog from '../../../components/HelpDialog';
import DateToolTip from '../../../components/DateToolTip';
import MessageLink from '../../mailgun/components/MessageLink';
import MessageStatus from '../../mailgun/components/MessageStatus.vue';

export default {
  components: {MessageStatus, MessageLink, DateToolTip, HelpDialog},
  props: {
    campaign: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
      messages: [],
      search: null,
    }
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
    headers() {
      let headers = [
        {
          text: 'Sent',
          value: 'created_at',
        },
        {
          text: 'Sender',
          value: 'sender.name',
        },
        {
          text: 'Recipient',
          value: 'recipient',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Delivered',
          value: 'delivered_at',
        },
        {
          text: 'Opened',
          value: 'opened_at',
        },
        {
          text: 'Clicked',
          value: 'clicked_at',
        },
        { // MLD-5202
          text: 'Failed',
          value: 'failed_at',
        },
      ];
      if (this.user.id === this.campaign.user_id) {
        headers = headers.filter(item => !['sender.name'].includes(item.value));
      }
      return headers;
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      if (this.loading) {
        return;
      }
      const form = {
        campaign_id: this.campaign.id,
        tag: 'campaign_email', // MLD-6403
        is_sharing_email: 1, // MLD-6403
      }
      this.loading = true;
      mailgunService.fetchMessages(form, 1_000)
        .then(data => {
          this.messages = orderBy(data, ['recipient'], ['asc']);
        })
        .catch(err => {
          this.$toast.error('An error occurred.');
        })
        .finally(() => {
          this.loading = false;
        })
    },
    exportMessages() {
      const form = {
        campaign_id: this.campaign.id,
        export: 1,
      }
      const filename = `${this.campaign.name} - emails.csv`
      try {
        return mailgunService.exportMessages(form, filename)
      } catch (e) {
        this.$toast.error('An error occurred.');
      }
    }
  }
}
</script>
